import React from 'react'
import '../styles.css'
import '../stylev2.css'
import '../custom.css'
export default function Team() {
  return (
    <div>
      <div id="SECTION-COORDI" className="base-container w-container">
        <div className="video-info-content-wrapper">
          <div className="video-info-block-wrapper">
            <h3
              data-w-id="db319d20-7649-22f9-2eac-83d178790800"
              style={{ opacity: 0 }}
            />
            <h3 className="vit-team">Patrons</h3>
            <div>
              <div>
                <div className="grid-item">
                  <div class="mention-card ">
                    <img
                      src="https://vitap.ac.in/wp-content/uploads/2020/12/Viswanthan-Sir.jpg"
                      alt="mention-card"
                    />
                    <h6>Dr. G. Viswanathan</h6>
                  </div>
                </div>
                <div className="grid-container"></div>
                <div class="Co-patrons-body">
                  <div class="Co-Patrons-wrapper">
                    <h3 class="vit-team2">Co-Patrons</h3>
                  </div>
                  <div class="grid-container">
                    <div className="grid-item">
                      <div class="mention-card">
                        <img
                          src="https://vitap.ac.in/wp-content/uploads/2020/12/Sankar-Sir.jpg"
                          alt="mention-card"
                        />
                        <h6>Dr.Sankar-Viswanathan</h6>
                      </div>
                    </div>
                    <div className="grid-item">
                      <div class="mention-card">
                        <img
                          src="https://vitap.ac.in/wp-content/uploads/2018/01/Sekhar-Sir-Resized.jpg"
                          alt="mention-card"
                        />
                        <h6>Dr. Sekar Viswanathan</h6>
                      </div>
                    </div>
                    <div className="grid-item">
                      <div class="mention-card">
                        <img
                          src="https://vitap.ac.in/wp-content/uploads/2020/12/GV-Selvam-Sir.jpg"
                          alt="mention-card"
                        />
                        <h6>Mr.G. V. Selvam</h6>
                      </div>
                    </div>

                    <div className="grid-item">
                      <div class="mention-card">
                        <img
                          src="https://vitap.ac.in/wp-content/uploads/2020/11/kottareddy.jpg"
                          alt="mention-card"
                        />
                        <h6>Dr. S. V. Kota Reddy</h6>
                      </div>
                    </div>
                    <div className="grid-item">
                      <div class="mention-card">
                        <img
                          src="https://vitap.ac.in/wp-content/uploads/2019/06/Dr.-JAGADISH-CHANDRAMUDIGANTI.jpg"
                          alt="mention-card"
                        />
                        <h6>Dr. Jagadish Chandramudiganti</h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="Co-patrons-body">
                  <div class="Co-Patrons-wrapper">
                    <h3 class="vit-team3">Event Coordinators</h3>
                  </div>
                  <div class="grid-container">
                    <div className="grid-item">
                      <div class="mention-card">
                        <img
                          src="https://vitap.ac.in/wp-content/uploads/2019/06/Dr.-SUDHAKAR-ILANGO-1.jpg"
                          alt="mention-card"
                        />
                        <h6>Dr. Sudhakar Ilango</h6>
                      </div>
                    </div>
                    <div className="grid-item">
                      <div class="mention-card">
                        <img
                          src="https://vitap.ac.in/wp-content/uploads/2019/06/Dr.-ANUPAMA-NAMBURU.jpg"
                          alt="mention-card"
                        />
                        <h6>Dr. Anupama Namburu</h6>
                      </div>
                    </div>
                    <div className="grid-item">
                      <div class="mention-card">
                        <img
                          src="https://vitap.ac.in/wp-content/uploads/2019/06/Mr.-K.-SAMUEL-JOHNSON.jpg"
                          alt="mention-card"
                        />
                        <h6>Mr. K. Samuel Johnson!</h6>
                      </div>
                    </div>
                    <div className="grid-item">
                      <div class="mention-card">
                        <img
                          src="https://vitap.ac.in/wp-content/uploads/2021/07/Monali-Bordoloi.jpg"
                          alt="mention-card"
                        />
                        <h6>Monali Bordoloi</h6>
                      </div>
                    </div>
                    <div className="grid-item">
                      <div class="mention-card">
                        <img src="" alt="mention-card" />
                        <h6>Dr. Aswathy R K</h6>
                      </div>
                    </div>
                    <div className="grid-item">
                      <div class="mention-card">
                        <img
                          src="https://vitap.ac.in/wp-content/uploads/2019/06/Dr.-V.-RAVINDRAKUMAR.jpg"
                          alt="mention-card"
                        />
                        <h6>Dr. V. Manikanta Ravindra Kumar</h6>
                      </div>
                    </div>
                    <div className="grid-item">
                      <div class="mention-card">
                        <img
                          src="https://vitap.ac.in/wp-content/uploads/2022/02/Suresh-Jagannadham.jpg"
                          alt="mention-card"
                        />
                        <h6>Dr. Suresh Jagannadham</h6>
                      </div>
                    </div>
                    <div className="grid-item">
                      <div class="mention-card">
                        <img
                          src="https://i.im.ge/2023/02/11/a3WyeD.DSC-0017-JPG.jpg"
                          alt="mention-card"
                        />
                        <h6>Dr. Sayyed Faizan Ali</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div class="column">
   <div class="card"> 
  <img class="ViswanthanSir" src="https://vitap.ac.in/wp-content/uploads/2020/12/Viswanthan-Sir.jpg" alt="Viswanthan-Sir">
    </div>
  </div>
  <div class="column">
    <div class="card"> 
   <img class="KotaReddySir" src="https://vitap.ac.in/wp-content/uploads/2020/11/kottareddy.jpg" alt="SV-Kota-Reddy-Sir">
    </div>
  </div>
  <div class="column">
    <div class="card"> 
   <img class="RegisterSir" src="https://vitap.ac.in/wp-content/uploads/2019/06/Dr.-JAGADISH-CHANDRAMUDIGANTI.jpg" alt="Register">
  </div>
    </div>
</div>
<div class="row">
 
  <div class="column">
    <div class="card"> 
   <img class="SudhakarSir" src="https://vitap.ac.in/wp-content/uploads/2019/06/Dr.-SUDHAKAR-ILANGO-1.jpg" alt="-SUDHAKAR-ILANGO-1">
    </div>
  </div>     
   <div class="column">
    <div class="card"> 
   <img class="AnupamaMam" src="https://vitap.ac.in/wp-content/uploads/2019/06/Dr.-ANUPAMA-NAMBURU.jpg" alt="-ANUPAMA-NAMBURU">
    </div>
  </div>      
   <div class="column">
    <div class="card"> 
   <img class="SamuelSir" src="https://vitap.ac.in/wp-content/uploads/2019/06/Mr.-K.-SAMUEL-JOHNSON.jpg" alt="-SAMUEL-JOHNSON">
    </div>
  </div>   
 <div class="column">
    <div class="card"> 
    <img class="MonaliMam" src="https://vitap.ac.in/wp-content/uploads/2021/07/Monali-Bordoloi.jpg" alt="Monali-Bordoloi">
    </div>
  </div>   
<div class="column">
    <div class="card"> 
     <img class="FaizanSir" src="https://i.im.ge/2023/01/19/sAlUpK.DSC-0017-JPG.jpg" alt="Faizan-Ali">
    </div>
  </div>                
  <div class="column">
    <div class="card"> 
     <img class="AswathyMam" src="https://i.im.ge/2023/01/19/sNxu8X.IMG-3659.jpg" alt="Aswathy">
    </div>
  </div>                  
          <div class="column">
    <div class="card"> 
     <img class="RavindraSir" src="https://vitap.ac.in/wp-content/uploads/2019/06/Dr.-V.-RAVINDRAKUMAR.jpg" alt="-RAVINDRAKUMAR">
    </div>
  </div>            
         <div class="column">
    <div class="card"> 
     <img class="SureshSir" src="https://vitap.ac.in/wp-content/uploads/2022/02/Suresh-Jagannadham.jpg" alt="Suresh-Jagannadham">
                    </div>
            </div>                     
   </div> 
 </div>                */}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
